var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
var NotAllow = /** @class */ (function (_super) {
    __extends(NotAllow, _super);
    function NotAllow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotAllow.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("h1", null, "403"),
            React.createElement("p", null, "You are not allowed to do this action. Please, contact your administrator.")));
    };
    return NotAllow;
}(React.PureComponent));
export { NotAllow };
